import * as _ from 'lodash';

export class Utils {
    public static defaultUuid: string = "00000000-0000-0000-0000-000000000000";

    public static isNullOrUndefined(obj: any) {
        return obj === undefined || obj === null;
    }

    public static getNumberAsStringWithPrecision(value: number, roundFactor: number = 2) {
        if (!this.isNullOrUndefined(value)) {
            return parseFloat(String(value)).toFixed(roundFactor);
        }
        return parseFloat(String(0)).toFixed(roundFactor);
    }

    public static clone(obj: any) {
        return _.cloneDeep(obj);
    }

    public static createRecord<K extends string, V>(key: K, value: V): Record<K, V> {
        return {[key]: value} as Record<K, V>;
    }
}